<svelte:options
  customElement={{
    tag: 'teo-side-by-side-editor',
    extend: extendWithStyles,
  }}
/>

<script lang="ts" module>
  import { onMount } from 'svelte';

  import { TeoCore } from '@/teoCore/TeoCore';
  // import type { AnalysisResult } from '@/teoCore/text/AnalysisResult';
  import { TeoText } from '@/teoCore/text/TeoText';
  import Editor from '@/ui/components/editor/Editor.svelte';
  import TextView from '@/ui/elements/textview/TextView.svelte';
  import { TeoContextProvider } from '@/utils/teo-context';

  import ConfigPanelElement from '../../../../webComponents/ConfigPanelElement.svelte';
  import { extendWithStyles } from '../../../../webComponents/web-component-utils';
  import EditorHeadline from '../editor/EditorHeadline.svelte';
</script>

<script lang="ts">
  let { teoCore, editorId }: { teoCore: TeoCore; editorId?: string } = $props();

  let text = $state('');
  let tpi = $state(0);
  let infoText = $state('');
  let disabled = $state(true);

  let variant = 'TextView' as 'TextView' | 'TextInput';

  // svelte-ignore non_reactive_update
  let editorText: TeoText = teoCore.createTemporaryText(' ');
  let editorTextId = $state(editorText.id);
  let loading: boolean = $state(false);
  let eventAiSuggestion: undefined | (() => void) = undefined;
  let eventOnActiveTextChanged: undefined | (() => void) = undefined;
  //const maxSigns = 4000;

  onMount(() => {
    // Inits the events to the current ext
    updateEvents();

    eventOnActiveTextChanged = teoCore.events.addEventListener(
      'activeTextChanged',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (detail: TeoText) => {
        updateEvents();
      },
    );

    return () => {
      eventOnActiveTextChanged?.();
      eventAiSuggestion?.();
    };
  });

  async function updateEvents() {
    // sets text of current active text
    updateText(teoCore.activeText.text);
    // Reads current tpi
    tpi = teoCore.activeText.analysis?.getTPI() ?? 0;
    disabled = false;

    eventAiSuggestion?.();
    eventAiSuggestion = teoCore.textCreator.addEventListener(
      'textCreatedFromAiSuggestion',
      (detail: TeoText) => {
        editorText = detail;
        editorTextId = editorText.id;
        console.log(editorText);
        loading = false;
      },
    );
  }

  function updateText(detail: string) {
    text = detail;
    infoText = '';
    //infoText = `${maxSigns - text.length} von ${maxSigns} Zeichen verbleibend.`;
  }

  function doSomeTeoApiCall(textContent: string) {
    console.log('doSomeTeoApiCall', textContent);
  }

  function plainLanguageTranslation(textContent: string) {
    loading = true;
    teoCore.textCreator.createPlainLanguage(textContent);
  }
</script>

<TeoContextProvider {teoCore}>
  <div class="flex h-full max-h-full w-full gap-4" id={editorId}>
    <div class="flex w-1/2 flex-col">
      <!-- //tslint:disable-next-line -->
      {#if variant === 'TextInput'}
        <div>
          <EditorHeadline text={teoCore.activeText}></EditorHeadline>
        </div>
        <div class="pb-4"><ConfigPanelElement {teoCore}></ConfigPanelElement></div>
        <div class="h-full max-h-full min-h-0">
          <TextView
            scrollable
            {variant}
            {tpi}
            {disabled}
            onTranslateClick={doSomeTeoApiCall}
            {infoText}
          />
        </div>
      {:else if variant === 'TextView'}
        <div>
          <EditorHeadline text={teoCore.activeText}></EditorHeadline>
        </div>
        <div class="h-full max-h-full min-h-0">
          <TextView
            scrollable
            {variant}
            {text}
            {tpi}
            {disabled}
            {loading}
            onTranslateClick={plainLanguageTranslation}
            helpTopicName="plain_language_translation"
            {infoText}
          />
        </div>
      {/if}
    </div>
    <div class="flex w-1/2 flex-col">
      {#key editorTextId}
        <div>
          <EditorHeadline text={editorText}></EditorHeadline>
        </div>
        <div class="h-full max-h-full min-h-0">
          <Editor text={editorText} mode="translation"></Editor>
        </div>
      {/key}
    </div>
  </div>
</TeoContextProvider>
